module.exports = __webpack_public_path__ + "img/Prog-final-Inperson-day2rms-v1.88690d99.svg";